import { CustomerClaimStatusEnum } from "./status-enum";

export const customerClaimStatusLabels = {
  [CustomerClaimStatusEnum.PENDING]: "Pending",
  [CustomerClaimStatusEnum.COMPLETED]: "Selesai",
  [CustomerClaimStatusEnum.CANCELLED]: "Batal",
};
